import type { Distance } from "@pdfking/math"
import { ToPixel } from "@pdfking/quantity"
import type { ColorID, PageShape } from "@pdfking/renderer-api"
import { HorizontalAlign, PlotFunction, VerticalAlign } from "@pdfking/renderer-api"

// `value` set `font` high in `color` on a line `width` wide from `x`, its foot
// at `y`, aligned along it by `horizontal_align`
export const PlainText = (
  value: string,
  x: Distance,
  width: Distance,
  y: Distance,
  font: Distance,
  color: ColorID,
  horizontal_align: HorizontalAlign = HorizontalAlign.LEFT
): PageShape => ({
  enum: PlotFunction.PLOT_TEXT,
  font_size: ToPixel(font),
  horizontal_align,
  position: { height: font, width, x, y },
  text: value,
  text_color: color,
  vertical_align: VerticalAlign.TOP,
})
